module.exports = __webpack_public_path__ + "img/icon-email.8ac90875.svg";